<template>
  <div>
    <div class="bg-default-dashboard">
      <div class=" py-lg-8 pt-lg-5">
        <b-container fluid style="width: 100%; position: relative;">
          <!-- <div style="padding-top: 100px;"> -->
          <div>
            <b-row class="mb-2">
              <b-col>
                <h1 class="text-white">QAQC - Punch List</h1>
              </b-col>
            </b-row>
            
            <b-row class="mb-2 punchlist-tab-container">
              <b-col>
                <!-- tabs -->
                <b-tabs content-class="mt-1" justified>
                  
                  <!-- punch list information & Item -->
                  <b-tab no-body title="Punch List Information & Item">
                    <!-- punch list information -->
                    <b-row class="mb-3">
                      <b-col class="mb-2" md="12" lg="6" xl="6">
                        <label class="mb-1 text-white" for="">Reference No</label>
                        <input type="text" disabled class="form-control" placeholder="" v-model="oModel.general_info.ref">
                      </b-col>
                      <b-col class="mb-2" md="12" lg="6" xl="6">
                        <label class="mb-1 text-white" for="">Contractor Company</label>
                        <input type="text" disabled class="form-control" placeholder="" v-model="oModel.general_info.contractor_company">
                      </b-col>
                      <b-col class="mb-2" md="12" lg="6" xl="6">
                        <label class="mb-1 text-white" for="">Site / Location</label>
                        <input type="text" disabled class="form-control" placeholder="" v-model="oModel.general_info.site">
                      </b-col>
                      <b-col class="mb-2" md="12" lg="6" xl="6">
                        <label class="mb-1 text-white" for="">Postal Code</label>
                        <input type="text" disabled class="form-control" placeholder="" v-model="oModel.general_info.postal_code">
                      </b-col>
                      <b-col class="mb-2" md="12" lg="12" xl="12" style="display: none;">
                        <!-- <b-card-footer style="float: right;" v-if="is_editable"> -->
                        <b-card-footer style="float: right;" >
                          <base-button type="tn btn-sm base-button btn-primary" @click="save_main_meter()">Update</base-button>
                        </b-card-footer>
                      </b-col>
                    </b-row>   

                    <hr class="hr" />

                    <!-- punch item(s) -->
                    <b-row class="mb-3">
                      <b-col>
                        <page-punch-item 
                          :share-data="oShare"
                          :sub-data="oModel.punch_item"                 
                        />
                      </b-col>
                    </b-row>

                  </b-tab>
                  
                  <!-- punch list closure -->
                  <b-tab no-body title="Punch List Closure">
                    <b-row>
                      <!-- acknowledgement / consent by Contractor -->
                      <b-col class="mb-2" md="12" lg="12" xl="4">
                        <b-row>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <h2 class="text-white">Contractor / Supervisor / Engineer / Manager</h2>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Name </label>
                            <b-form-input placeholder="" v-model="oModel.closure_contractor.contractor_name" disabled></b-form-input>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Date </label>
                            <base-input name="Date" type="date" v-model="oModel.closure_contractor.contractor_date" disabled></base-input>
                          </b-col>
                        </b-row>
                      </b-col>

                      <!-- acknowledgement / consent by QAQC -->
                      <b-col class="mb-2" md="12" lg="12" xl="4">
                        <b-row>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <h2 class="text-white">Sembcorp QA/QC</h2>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Name </label>
                            <b-form-input placeholder="" v-model="oModel.closure_qaqc.qaqc_name" disabled></b-form-input>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Date </label>
                            <base-input name="Date" type="date" v-model="oModel.closure_qaqc.qaqc_date" disabled></base-input>
                          </b-col>
                        </b-row>
                      </b-col>

                      <!-- acknowledgement / consent by O&M -->
                      <b-col class="mb-2" md="12" lg="12" xl="4">
                        <b-row>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <h2 class="text-white">Sembcorp Project / O&M</h2>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Name </label>
                            <b-form-input placeholder="" v-model="oModel.closure_onm.onm_name" disabled></b-form-input>
                            <input type="checkbox" id="checkbox" v-model="oModel.closure_onm.onm_acknowledge"> <span class="punch_item_consent">By selecting this checkbox, you acknowledge and consent to electronically sign and approve this section.</span>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Date </label>
                            <base-input name="Date" type="date" v-model="oModel.closure_onm.onm_date"></base-input>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <label for="" class="text-white">Remarks </label>
                            <b-form-input placeholder="" v-model="oModel.closure_onm.onm_remarks"></b-form-input>
                          </b-col>
                          <b-col class="mb-2" md="12" lg="12" xl="12">
                            <base-button type="tn btn-sm base-button btn-primary" @click="punchlist_acknowledgement('onm')" v-if="is_consent_onm">Submit</base-button>
                          </b-col>
                        </b-row>
                      </b-col>

                    </b-row>
                  </b-tab>    

                </b-tabs> 
              </b-col>
            </b-row>

          </div>
        </b-container>
      </div>
    </div>

    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>   

  </div>
</template>

<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";
import jsonFormData from 'json-form-data';

import PagePunchItem from './subform/punch_item.vue';


export default {
  name: "QAQCPunchlist",
  components: {
    PagePunchItem,
  },
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  // mixins: [ErrorFunctionMixin, CustomLibHelper],
  data() {
    return {
      oDev: {
        debug: true,
      },
      oField: {
        is_punch_item_all_approve: true,
        //_ why need this 3 fields below, cause there is no specific status that can be use,
        //  and if we use the tick button on the UI, it'll mess up with hide/when because it'll be use instantly (reactivity)
        is_acknowledge_by_epc: false,
        is_acknowledge_by_qaqc: false,
        is_acknowledge_by_onm: false,
      },
      oShare: {
				user: null,
        is_epc: false,
        is_qaqc: false,
        is_onm: false,
        is_acknowledge_by_onm: false,
				site_by_epc: [],
				status_tnc: 'DRAFT',
			},
      oModel: {
        allQAQC: null,
        general_info: {
          site_id: '',
          site: '',
          contractor_company: '',
          ref: '',
          postal_code: '',
        },
        punch_item:[],
        closure_contractor: {
          contractor_name: '',
          // contractor_signature_image: '',
          contractor_acknowledge: 0,
          contractor_date: null,
          contractor_remarks: '',
        },
        closure_qaqc: {
          qaqc_name: '',
          // qaqc_signature_image: '',
          qaqc_acknowledge: 0,
          qaqc_date: null,
          qaqc_remarks: '',
        },
        closure_onm: {
          onm_name: '',
          // onm_signature_image: '',
          onm_acknowledge: 0,
          onm_date: null,
          onm_remarks: '',
        },
      },


    };
  },
  computed: {
    is_consent_epc() {
      return this.oShare.is_epc && !this.oField.is_acknowledge_by_epc;
    },
    is_consent_qaqc() {
      return this.oShare.is_qaqc && this.oField.is_acknowledge_by_epc && !this.oField.is_acknowledge_by_qaqc;
    },
    is_consent_onm() {
      return this.oShare.is_onm && this.oField.is_acknowledge_by_qaqc && !this.oField.is_acknowledge_by_onm;
    },
    // is_editable() {
    //   return this.oShare.is_epc && this.oShare.status_tnc != 'APPROVED'
    // }
  },
  created() {
    const LoginUser = JSON.parse(window.localStorage.getItem("loginUser"));
		this.oShare.user = LoginUser;

    // _ dummy test user
		// this.oShare.user = {
		// 	email: "troyspd@outlook.com",
		// 	id: 405,
		// 	name: "Troy EPC",
		// 	role_id: 12
		// }

    // this.oShare.user = {
		// 	email: "cheewee.ng@sembcorp.com",
		// 	id: 63,
		// 	name: "Chee Wee",
		// 	role_id: 14
		// }
  },
  mounted() {
    // console.log(users)
    //  this.formData.countAcTestEntry = 4;
    this.getSelectedQAQC();
  },
  methods: {
    getSelectedQAQC() {
      axios
      .get(apiDomain + 'e_forms/punchlist_form/' + this.$route.params.id, { headers: getHeader() })
      .then(response => {
        if (response.status === 200) {
          this.oModel.allQAQC = response.data.data;
          // this.oShare.status_tnc = this.oModel.allQAQC.status;status_tnc

          this.devMsg(this.oDev.debug, 'getSelectedQAQC => this.oModel.allQAQC', 'gs')
          this.devMsg(this.oDev.debug, this.oModel.allQAQC, 'ge')
        }
      })
      .catch(error => {
        // console.log(error.response.status);
        console.log(error.response);
        this.errorFunction(error, "get QAQC list data");
      })
      .finally(() => { 

        this.populateModel_general_info();
        this.populateModel_punchlist_closure();
        ( this.oModel.allQAQC.punchListItems != null ) ? this.populateModel_punch_item() : '';

        this.set_fields_based_on_user_role();
      });
    },
    populateModel_general_info() {
      this.devMsg(this.oDev.debug, 'populateModel_general_info', 'gs');

      // console.log(this.oModel.allQAQC.test_instruments);
      let dataAllQAQC = this.oModel.allQAQC;

      this.oModel.general_info.site_id = dataAllQAQC.site_id;
      this.oModel.general_info.site = dataAllQAQC.site;
      this.oModel.general_info.ref = dataAllQAQC.ref;
      this.oModel.general_info.postal_code = dataAllQAQC.postal_code;
      this.oModel.general_info.contractor_company = dataAllQAQC.contractor_company;

      this.devMsg(this.oDev.debug, this.oModel.general_info, 'ge');
    },
    populateModel_punch_item() {
      this.devMsg(this.oDev.debug, 'populateModel_punch_item', 'gs');

      this.oModel.punch_item = this.oModel.allQAQC.punchListItems;

      this.devMsg(this.oDev.debug, this.oModel.punch_item, 'ge');
    }, 
    populateModel_punchlist_closure() {
      this.devMsg(this.oDev.debug, 'populateModel_punchlist_closure', 'gs');

      //_ contrator
      this.oModel.closure_contractor.contractor_name = this.oModel.allQAQC.contractor_name;
      this.oModel.closure_contractor.contractor_acknowledge = this.oModel.allQAQC.contractor_acknowledge;
      this.oModel.closure_contractor.contractor_date = this.oModel.allQAQC.contractor_date;
      this.oModel.closure_contractor.contractor_remarks = this.oModel.allQAQC.contractor_remarks;
      this.oField.is_acknowledge_by_epc = this.oModel.allQAQC.contractor_acknowledge;

      this.devMsg(this.oDev.debug, 'this.oModel.closure_contractor');
      this.devMsg(this.oDev.debug, this.oModel.closure_contractor);

      // qaqc
      this.oModel.closure_qaqc.qaqc_name = this.oModel.allQAQC.qaqc_name;
      this.oModel.closure_qaqc.qaqc_acknowledge = this.oModel.allQAQC.qaqc_acknowledge;
      this.oModel.closure_qaqc.qaqc_date = this.oModel.allQAQC.qaqc_date;
      this.oModel.closure_qaqc.qaqc_remarks = this.oModel.allQAQC.qaqc_remarks;
      this.oField.is_acknowledge_by_qaqc = this.oModel.allQAQC.qaqc_acknowledge;
      
      this.devMsg(this.oDev.debug, 'this.oModel.closure_qaqc');
      this.devMsg(this.oDev.debug, this.oModel.closure_qaqc);

      // o&m
      this.oModel.closure_onm.onm_name = this.oModel.allQAQC.onm_name;
      this.oModel.closure_onm.onm_acknowledge = this.oModel.allQAQC.onm_acknowledge;
      this.oModel.closure_onm.onm_date = this.oModel.allQAQC.onm_date;
      this.oModel.closure_onm.onm_remarks = this.oModel.allQAQC.onm_remarks;
      this.oField.is_acknowledge_by_onm = this.oModel.allQAQC.onm_acknowledge;
      this.oShare.is_acknowledge_by_onm = this.oModel.allQAQC.onm_acknowledge;
      
      this.devMsg(this.oDev.debug, '', 'ge');
    },

    //_ 
    set_fields_based_on_user_role() {
      /*
        3	-> admin
        12	-> contractor
        15	-> engineer
        18 	-> O&M
        10	-> project engineer
        9	-> project manager
        14	-> QAQC    
      */

      let tmpActiveUser = this.oShare.user.name;
      //_ EPC
      if ( this.oShare.user.role_id == '12' || this.oShare.user.role_id == '3' ) {
        this.oShare.is_epc = true;
        // - not use anymore, since this field is auto populated when all punch items are approved
        // this.oModel.closure_contractor.contractor_name = ( this.oModel.allQAQC.contractor_name !== null ) ? this.oModel.allQAQC.contractor_name : tmpActiveUser;
      };

      //_ QAQC
      if ( this.oShare.user.role_id == '14' || this.oShare.user.role_id == '3' ) {
        this.oShare.is_qaqc = true;
        // - not use anymore, since this field is auto populated when all punch items are approved
        // this.oModel.closure_qaqc.qaqc_name = ( this.oModel.allQAQC.qaqc_name !== null ) ? this.oModel.allQAQC.qaqc_name : tmpActiveUser;
      };

      //_ O&M
      if ( this.oShare.user.role_id == '18' || this.oShare.user.role_id == '3' ) {
        this.oShare.is_onm = true;
        this.oModel.closure_onm.onm_name = ( this.oModel.allQAQC.onm_name !== null ) ? this.oModel.allQAQC.onm_name : tmpActiveUser;
      };
    },


    //_ ACKNOWLEDGEMENT
    punchlist_acknowledgement( whoseAction='' ) {
      this.devMsg(this.oDev.debug, 'punchlist_acknowledgement', 'gs')
    
      if (this.check_punch_items()) {
        if ( whoseAction == 'contractor' ) {
          this.update_acknowledgement_by_contractor();
        } else if ( whoseAction == 'qaqc' ) {
          this.update_acknowledgement_by_qaqc();
        } else if ( whoseAction == 'onm' ) {
          this.update_acknowledgement_by_onm();
        } else {
          this.redErrorNotify( "<b>Invalid action .</b>" );
        }
      } else {
        this.redErrorNotify( "<b>All punch items must be approved.</b>" );
      };

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    check_punch_items() {
      this.devMsg(this.oDev.debug, 'check_punch_item', 'gs')

      let retval_status = true;
      if ( this.oModel.allQAQC.punchListItems.length > 0 ) {
        this.oModel.allQAQC.punchListItems.forEach( (e => {
          if ( e.status != 'APPROVED') retval_status = false
        }))
      } else {
        retval_status = false
      }

      this.devMsg(this.oDev.debug, '', 'ge')

      return retval_status;
    },

    //_ acknowledgement - CONTRACTOR
    check_required_data_by_contractor() {
      this.devMsg(this.oDev.debug, 'check_required_data_by_contractor', 'gs')

      this.devMsg(this.oDev.debug, this.oModel.closure_contractor)

      let checker = false;
			if (
        !this.oModel.closure_contractor.contractor_name ||
        this.oModel.closure_contractor.contractor_acknowledge == 0 ||
        !this.oModel.closure_contractor.contractor_date ||
        !this.oModel.closure_contractor.contractor_remarks
			) {
        
				if (this.oModel.closure_contractor.contractor_name === '') {
					this.redErrorNotify(
						"<b>Invalid Input : Name is a Mandatory Field.</b>"
					);
				} else if (this.oModel.closure_contractor.contractor_acknowledge == 0) {
					this.redErrorNotify(
						"<b>Submitting required your acknowledgement and consent.</b>"
					);
				} else if (this.oModel.closure_contractor.contractor_date == null) {
					this.redErrorNotify(
						"<b>Invalid Input : Date is a Mandatory Field.</b>"
					);
				} else if (this.oModel.closure_contractor.contractor_remarks == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Remark is a Mandatory Field.</b>"
					);
				} else {
					this.redErrorNotify(
						"<b>Invalid Input : Please fill in all the Mandatory Fields.</b>"
					);
				}
			} else {
				checker = true;
			}

      this.devMsg(this.oDev.debug, '', 'ge')

      return checker;
    },
    update_acknowledgement_by_contractor() {
      this.devMsg(this.oDev.debug, 'update_acknowledgement_by_contractor', 'gs')

      if ( this.check_required_data_by_contractor() ) {
        this.devMsg(this.oDev.debug, 'POST data update_acknowledgement_by_contractor')

        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'e_forms/punch_list_acknowledge_by_contractor/' + this.$route.params.id;
        let formData = jsonFormData(this.oModel.closure_contractor);

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>Contractor - Submitted Punchlist Closure Entry Successfully.</b>');

            this.$router.go(0);
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Contractor - Punchlist Closure Entry Update");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.$refs['modal-loading-in-progress'].hide();
        });          
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },

    //_ acknowledgement - QAQC
    check_required_data_by_qaqc() {
      this.devMsg(this.oDev.debug, 'check_required_data_by_qaqc', 'gs')

      let checker = false;
      if (
        !this.oModel.closure_qaqc.qaqc_name ||
        this.oModel.closure_qaqc.qaqc_acknowledge == 0 ||
        !this.oModel.closure_qaqc.qaqc_date ||
        !this.oModel.closure_qaqc.qaqc_remarks
      ) {
        if (this.oModel.closure_qaqc.qaqc_name === '') {
          this.redErrorNotify(
            "<b>Invalid Input : Name is a Mandatory Field.</b>"
          );
        } else if (this.oModel.closure_qaqc.qaqc_acknowledge == 0) {
          this.redErrorNotify(
            "<b>Submitting required your acknowledgement and consent.</b>"
          );
        } else if (this.oModel.closure_qaqc.qaqc_date == null) {
          this.redErrorNotify(
            "<b>Invalid Input : Date is a Mandatory Field.</b>"
          );
        } else if (this.oModel.closure_qaqc.qaqc_remarks == '') {
          this.redErrorNotify(
            "<b>Invalid Input : Remark is a Mandatory Field.</b>"
          );
        } else {
          this.redErrorNotify(
            "<b>Invalid Input : Please fill in all the Mandatory Fields.</b>"
          );
        }
      } else {
        checker = true;
      }

      this.devMsg(this.oDev.debug, '', 'ge')

      return checker;      
    },
    update_acknowledgement_by_qaqc() {
      this.devMsg(this.oDev.debug, 'update_acknowledgement_by_qaqc', 'gs')

      if ( this.check_required_data_by_qaqc() ) {
        this.devMsg(this.oDev.debug, 'POST data update_acknowledgement_by_qaqc')
        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'e_forms/punch_list_acknowledge_by_qaqc/' + this.$route.params.id;
        let formData = jsonFormData(this.oModel.closure_qaqc);

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>QA/QC - Submitted Punchlist Closure Entry Successfully.</b>');

            this.$router.go(0);
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "QA/QC - Punchlist Closure Entry Update");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.$refs['modal-loading-in-progress'].hide();
        });   

      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },    

    //_ acknowledgement - O&M
    check_required_data_by_onm() {
      this.devMsg(this.oDev.debug, 'check_required_data_by_onm', 'gs')

      let checker = false;
      if (
        !this.oModel.closure_onm.onm_name ||
        this.oModel.closure_onm.onm_acknowledge == 0 ||
        !this.oModel.closure_onm.onm_date ||
        !this.oModel.closure_onm.onm_remarks
      ) {
        if (this.oModel.closure_onm.onm_name === '') {
          this.redErrorNotify(
            "<b>Invalid Input : Name is a Mandatory Field.</b>"
          );
        } else if (this.oModel.closure_onm.onm_acknowledge == 0) {
          this.redErrorNotify(
            "<b>Submitting required your acknowledgement and consent.</b>"
          );
        } else if (this.oModel.closure_onm.onm_date == null) {
          this.redErrorNotify(
            "<b>Invalid Input : Date is a Mandatory Field.</b>"
          );
        } else if (this.oModel.closure_onm.onm_remarks == '') {
          this.redErrorNotify(
            "<b>Invalid Input : Remark is a Mandatory Field.</b>"
          );
        } else {
          this.redErrorNotify(
            "<b>Invalid Input : Please fill in all the Mandatory Fields.</b>"
          );
        }
      } else {
        checker = true;
      }

      this.devMsg(this.oDev.debug, '', 'ge')

      return checker;   
    },
    update_acknowledgement_by_onm() {
      this.devMsg(this.oDev.debug, 'update_acknowledgement_by_onm', 'gs')

      if ( this.check_required_data_by_onm() ) {
        this.devMsg(this.oDev.debug, 'POST data update_acknowledgement_by_onm')


        let api_url = apiDomain + 'e_forms/punch_list_acknowledge_by_onm/' + this.$route.params.id;
        let formData = jsonFormData(this.oModel.closure_onm);

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>O&M - Submitted Punchlist Closure Entry Successfully.</b>');

            this.$router.go(0);
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "O&M - Punchlist Closure Entry Update");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.$refs['modal-loading-in-progress'].hide();
        });           
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },

  }
};
</script>

<!-- custom -->
<style scoped>
/deep/ hr{
  background-color: white;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

/deep/ .form-control:disabled, .form-control[readonly] {
  background-color: #7892ad;
  opacity: 1;
}

/deep/ .dropdown, .dropleft, .dropright, .dropup {
  border: 1px solid white;
  border-radius: 0.25rem;
}

/deep/ .modal-row-category {
  padding-top: 3px;
}

/deep/ .punch_item_consent {
  color: #ffffff;
  font-size: 14px;
}
</style>

<!-- tabs -->
<style scoped>
/deep/ .punchlist-tab-container {
  padding: 10px;
  border-radius: 0.75rem;
  background-color: #306b74;
  margin-left: 10px;
  margin-right: 10px;
}

/deep/ .tab-content {
  padding: 10px;
}

/deep/ .card-footer {
  /* padding: 0.5rem 0.5rem; */
  padding-bottom: 15px;
  background-color: #306b74;
  border-top: 1px solid rgba(0, 0, 0, .05);
}
</style>

<!-- custom style wizard -->
<style scoped>
/deep/ .step-footer {
  display: none;
}

/deep/ .step-body {
  background-color: #25535a !important;
}

/deep/ .step-pills {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #2c545a;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  padding: 1rem;
  border-radius: 1rem;
  -webkit-box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
}

/deep/ .vue-step-wizard {
  width: 100%;
  background-color: #23454a !important;
  border-radius: .25em;
}

/deep/ .step-pills .step-item {
  margin: 5px;
  font-size: 11px;
  font-weight: bold;
}

/deep/ .step-pills .step-item.active {
  border: 3px solid #4b8aeb;
}

/deep/ .list-group-item {
  padding: 0.25rem 0.55rem;
}

/deep/ .form-group {
  padding: 5px;
}

/deep/ .step-button-previous {
  background-color: #145e4a;
}

/deep/ .step-button-next {
  background-color: #295181;
}
</style>

<!-- form (2) AC Test -->
<style scoped>
/deep/ .ac-test-info {
  width: 150px;
}

/deep/ .ac-test-phase {
  width: 75px;
}
</style>

<!-- form validation -->
<style scoped>
/deep/ .is-invalid {
  border-color: red;
}

/deep/ .error {
  color: red;
}
</style>